var _name$code$encode$dec = {
  name: 'json',
  code: 512,
  encode: function encode(json) {
    return new TextEncoder().encode(JSON.stringify(json));
  },
  decode: function decode(bytes) {
    return JSON.parse(new TextDecoder().decode(bytes));
  }
},
    name = _name$code$encode$dec.name,
    code = _name$code$encode$dec.code,
    encode = _name$code$encode$dec.encode,
    decode = _name$code$encode$dec.decode;
export { name, code, encode, decode };